import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!url || !anon) {
  throw new Error(
    "Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Create web/.env.local for local dev.",
  );
}

export const supabase = createClient(url, anon, {
  auth: { persistSession: false },
});

export type Snapshot = {
  id: number;
  ts: string;
  cash_cents: number;
  portfolio_value_cents: number;
  total_value_cents: number;
  net_deposits_cents: number;
};
